import React from 'react'
import PropTypes from 'prop-types'

import {googleMapsLink} from 'lib/util'

const addressText = (address, name) => {
  const validAddress = address && address.street && address.postalArea && address.postalCode
  const addressText = validAddress
    ? `${address.street}, ${address.postalCode} ${address.postalArea}`
    : ''

  return (
    <div>
      {name}<br />
      {addressText}
    </div>
  )
}

const EstatePerson = ({person}) => {
  const mapLink = person && person.customer
    ? googleMapsLink(person.customer.location)
    : null

  const phoneNumbers = []
  if (person.phone) phoneNumbers.push(person.phone)
  if (person.phoneSecondary) phoneNumbers.push(person.phoneSecondary)

  return (
    <div>
      <h3>{person.name}</h3>
      {phoneNumbers.map((number, i) => (
        <p key={i}>Telefon: <a href={`tel://${number}`}>{number}</a></p>
      ))}
      {!!person.email && (
        <p>E-post: <a href={`mailto:${person.email}`}>{person.email}</a></p>
      )}

      {!!(person.customer) && (
        <div>
          Postadresse: {addressText(person.customer.address, person.customer.name)}
        </div>
      )}

      {!!(person.customer) && !!(person.customer.officeAddress) && (
        <div style={{marginTop: '1em'}}>
          Kontoradresse: {addressText(person.customer.officeAddress, person.customer.name)}

          {!!person.customer.location && (
            <span>
               <a href={mapLink} target="_blank" rel="noopener noreferrer">
                Link til kart
              </a>
            </span>
          )}
        </div>
      )}
    </div>
  )
}

EstatePerson.propTypes = {
  person: PropTypes.object.isRequired,
}

export default EstatePerson
